import React from 'react';
import PropTypes from 'prop-types';
import { parseISO, addHours } from 'date-fns';

import { getOfferPageUrl } from '@spa/shared/utils/redirect';
import { isNew } from '@spa/shared/containers/Card/transformer';
import { cityCodeToCitySlug } from '@spa/shared/utils/cityCodeToCitySlug';
import OfferCard from '@spa/shared/components/Search/Card/OfferCard';
import { ACCOMMODATION_TYPE_CODE } from '@spa/shared/constants/accommodationType';

const Recommendation = ({
  recommendation,
  cityCode,
  wishlist,
  showTrustedTag,
  isMobile,
  language,
  t,
  handleOfferClick,
  handleWishlistClick,
  disableWishlist,
  withMapOpened
}) => {
  const {
    id: offerId,
    attributes: {
      accommodation_offer: {
        title,
        price,
        max_guests,
        available_from,
        all_bills_included,
        number_of_bedrooms,
        is_instant_booking,
        exclusive,
        created_at: createdAt,
        is_sold_out: isSoldOut
      },
      property: { id: propertyId, type: typeCode, accommodation_type: accommodationTypeCode, verified },
      accommodation_provider: {
        verifications: { trusted: isTrusted }
      },
      photos
    }
  } = recommendation;
  const isResidence =
    accommodationTypeCode === ACCOMMODATION_TYPE_CODE.RESIDENCE && typeCode === ACCOMMODATION_TYPE_CODE.RESIDENCE;
  const photosWithPath = photos.map(photo => ({
    ...photo,
    path: `${process.env.CDN_PHOTOS_URL}/property-photos/${photo?.hash}/small.jpg`
  }));

  const href = getOfferPageUrl({
    city: cityCodeToCitySlug(cityCode),
    offerId,
    withMapOpened,
    isResidence,
    propertyId: isResidence ? propertyId : null,
    language
  });
  const tag = [
    { is: isSoldOut, key: 'Sold out' },
    { is: is_instant_booking, key: 'Instant booking' },
    { is: exclusive, key: 'Uniplaces Exclusive' },
    { is: isNew(createdAt), key: 'New' },
    { is: verified, key: 'Checked' },
    { is: showTrustedTag && isTrusted, key: 'Trusted Landlord' }
  ].find(({ is }) => !!is);

  const isOfferOnWishlist =
    wishlist?.cities?.items.some(({ accommodation_offer_ids }) => accommodation_offer_ids?.includes(+offerId)) || false;

  return (
    <OfferCard
      key={offerId}
      offerId={offerId}
      title={title}
      price={{ ...price, currencyCode: price.currency_code }}
      isMobile={isMobile}
      photos={photosWithPath}
      maxGuests={max_guests}
      availableFrom={addHours(parseISO(available_from), 12)}
      isBillsIncluded={all_bills_included}
      numberOfRooms={number_of_bedrooms}
      language={language}
      href={href}
      tag={tag ? t(tag.key) : null}
      disableWishlist={disableWishlist}
      disableGallerySlide={isMobile}
      handleWishlistClick={handleWishlistClick}
      isOfferOnWishlist={isOfferOnWishlist}
      handleOfferClick={e => handleOfferClick(e, href, recommendation)}
    />
  );
};

Recommendation.propTypes = {
  recommendation: PropTypes.object,
  cityCode: PropTypes.string,
  wishlist: PropTypes.object,
  showTrustedTag: PropTypes.bool,
  isMobile: PropTypes.bool,
  language: PropTypes.string,
  t: PropTypes.func,
  handleOfferClick: PropTypes.func,
  handleWishlistClick: PropTypes.func,
  disableWishlist: PropTypes.bool,
  withMapOpened: PropTypes.bool
};

export default Recommendation;
